import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneLink'
})
export class PhoneLinkPipe implements PipeTransform {

  transform(value: string, phone: string | undefined): unknown {
    return phone ? value.replace(phone, `<a href="tel:${phone}" class="blue-text link-decoration">${phone}</a`) : value
  }


}
